import _ from 'lodash';
import { useEffect, useState } from 'react';

const AccordionTab = ({ children, className, headerClass, open, onClick = _.noop }) => {
  const [isOpen, setIsOpen] = useState(open);

  const handleClick = (event) => {
    if (
      (event?.target?.classList?.contains('m-accordion__header') ?? false) &&
      (event?.target?.classList?.contains(headerClass) ?? false)
    ) {
      setIsOpen(!isOpen);
      onClick(!isOpen);
    }
  };

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  return (
    <div
      className={`spo-m-accordion__tab m-accordion__tab ${className} ${isOpen ? 'is-open' : 'is-closed'}`}
      onClick={handleClick}
    >
      {children}
    </div>
  );
};

export default AccordionTab;
